PRE_EVENT_COUNTDOWN